export default "__VITE_ASSET__CwAbSC82__"